<template>
  <div>
    <view-options elementId="LinkedinAds" />
    <div class="product-view" id="LinkedinAds">
      <div>
        <div class="lds-ellipsis" v-if="Product.length === 0">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <ad-goals
          v-bind:totalImpressions="TotalImpressions /*Sample Data*/"
          v-bind:totalClicks="TotalClicks /*Sample Data*/"
          :wording="wordings"
        ></ad-goals>
        <section class="widget brand-impact">
          <h3 class="widget-title">Impacto de su marca en el tiempo</h3>
          <card type="line-chart">
            <div class="card-top">
              <div class="card-header">
                <h4 class="card-title">Impresiones y clicks</h4>
              </div>
            </div>
            <div class="card-content">
              <impressions
                :totalImpressions="Product.totalImpressions || 0"
                :impressions="Product.impressions || []"
                :clicks="Product.clicks || []"
                :imp="impressionsChartOptions"
                :labelType="'Clicks'"
              ></impressions>
            </div>
          </card>
        </section>
      </div>
      <mq-layout mq="laptop+" class="centered">
        <section class="mobile-canvas">
          <img src="@/assets/images/linkedin_icon.png" alt />
        </section>
      </mq-layout>
      <section class="widget campaign-widget">
        <h3 class="widget-title">Métricas de sus anuncios en Linkedin</h3>
        <div class="widgets-container">
          <card-metric :metric="TotalCTR" :title="'CTR'" :description="getDefinitions().CTR" :icon="'percent'" />
          <card-metric :metric="TotalCPC" :title="'CPC'" :description="getDefinitions().CPC" :icon="'dollar-sign'" />
          <card-metric :metric="TotalLikes" :title="'Likes'" :description="getDefinitions().LIKES" :icon="'heart'" />
          <card-metric :metric="TotalComments" :title="'Comentarios'" :description="getDefinitions().COMMENTS" :icon="'comment'" />
          <card-metric :metric="TotalVideoViews" :title="'Vistas al Video'" :description="getDefinitions().VIDEO_VIEWS" :icon="'play'" />
          <card-metric :metric="TotalPageClicks" :title="'Clicks a la página'" :description="getDefinitions().PAGE_CLICKS" :icon="'mouse-pointer'" />
        </div>
      </section>
      <section class="widget campaign-widget" v-if="campaignData.length !== 0">
        <h3 class="widget-title">Campañas</h3>
        <card>
          <table class="table">
            <thead>
              <th>Campaña</th>
              <th>Impresiones</th>
              <th>Clicks</th>
              <th>CTR medio</th>
              <th>CPC medio</th>
            </thead>
            <tbody>
              <tr v-for="(campaignData, index) in campaignData" :key="index">
                <td>{{ campaignData.name }}</td>
                <td>{{ Number(campaignData.impressions).toLocaleString() }}</td>
                <td>{{ Number(campaignData.clicks).toLocaleString() }}</td>
                <td>{{ campaignData.ctr }}%</td>
                <td>${{ campaignData.cpc }}</td>
              </tr>
            </tbody>

            <thead>
              <tr>
                <th>Total</th>
                <th>{{ TotalImpressions.toLocaleString() }}</th>
                <th>{{ TotalClicks.toLocaleString() }}</th>
                <th>{{ TotalCTR }}%</th>
                <th>${{ TotalCPC }}</th>
              </tr>
            </thead>
          </table>
        </card>
      </section>
      <section
        class="widget campaign-widget"
        v-if="campaignLocationData.length !== 0"
      >
        <h3 class="widget-title">Ubicaciones de la campaña</h3>
        <card class="responsive-table">
          <table class="table">
            <thead>
              <!-- <th>Campaña</th> -->
              <th>Ubicación de la segmentación</th>
              <th>Impresiones</th>
              <th>Clicks</th>
            </thead>
            <tbody>
              <tr
                v-for="(campaignLocationData, index) in campaignLocationData"
                :key="index"
              >
                <td>{{ campaignLocationData.location }}</td>
                <td>
                  {{
                    Number(campaignLocationData.impressions).toLocaleString()
                  }}
                </td>
                <td>
                  {{ Number(campaignLocationData.clicks).toLocaleString() }}
                </td>
              </tr>
            </tbody>

            <thead>
              <tr>
                <th colspan="1">Total</th>
                <th>{{ TotalLocationCampains.Impresiones.toLocaleString() }}</th>
                <th>{{ TotalLocationCampains.Clicks.toLocaleString() }}</th>
              </tr>
            </thead>
          </table>
        </card>
      </section>
    </div>
    <div class="export" id="export"></div>
  </div>
</template>
<script>
import Impressions from "@/components/ApexchartCustom/Impressions.vue";
import CardMetric from "../../components/Card/CardMetric.vue";
import ViewOptions from "@/components/ViewOptions.vue";
import AdGoals from "@/components/Widgets/AdGoals.vue";
import { mapGetters } from "vuex";

// REQUEST
import { getSummaryReport } from "../../services/linkedin.service";
import { validateProductExpirationDate } from "../../util";
import { ADS_DEFINITIONS } from "../../constants";

export default {
  name: "linkedin-ads",
  components: {
    ViewOptions,
    AdGoals,
    Impressions,
    CardMetric
  },
  data() {
    return {
      TotalImpressions: 0,
      TotalClicks: 0,
      TotalCPC: 0.0,
      TotalCTR: 0.0,
      TotalComments: 0,
      TotalPageClicks: 0,
      TotalLikes: 0,
      TotalVideoViews: 0,
      ConversionActions: [],
      AllConversionActions: [],
      TotalCampains: {
        Impresiones: 0,
        Clicks: 0,
        CTR: 0,
        CPC: 0,
        Conversions: 0
      },
      TotalLocationCampains: {
        Impresiones: 0,
        Clicks: 0,
        Conversions: 0,
        ConversionRate: 0
      },
      TotalPhoneCalls: 0,
      isAxesa: 0,
      isTrue: false,
      haveAudience: false,
      Product: [],
      PhoneCalls: [],
      ADS: [],
      wordings: {
        Impressions:
          "Cantidad de veces que su publicidad fue expuesta a su público objetivo",
        Clicks: "Interacciones con la audiencia"
      },
      productData: {
        totalImpressions: 0,
        totalClicks: 0
      },
      audienceInteractionSeries: [],
      audienceInteractionChartOptions: {
        colors: [
          "#0A286E",
          "#0E3593",
          "#1248C9",
          "#3772FF",
          "#08ACFF",
          "#93ABE6",
          "#BECDF0"
        ],
        labels: [],
        legend: {
          position: "bottom"
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ]
      },
      keywordDataTotal: {},
      keywordData: [],
      campaignData: [],
      campaignLocationData: [],

      impressionsSeries: [
        {
          name: "Impresiones",
          data: []
        },
        {
          name: "Clicks",
          data: []
        }
      ],
      impressionsChartOptions: {
        tooltip: {
          x: {
            show: true,
            format: "dd MMM",
            formatter: undefined
          },

          y: {
            formatter: function(
              value
              // { series, seriesIndex, dataPointIndex, w }
            ) {
              return value.toLocaleString();
            }
          }
        },
        responsive: [
          {
            breakpoint: undefined,
            options: {
              width: "100%"
            }
          }
        ],
        chart: {
          zoom: {
            enabled: false
          },
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          // width: [5, 7, 5],
          curve: "smooth"
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: "#f1f1f1"
        }
      },
      genderSeries: [
        {
          data: []
        }
      ],
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      ageSeries: [
        {
          data: []
        }
      ],
      ageChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      devicesSeries: [
        {
          data: []
        }
      ],
      devicesChartOptions: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: []
        }
      },
      adListings: [
        {
          listingIframeUrl:
            "http://caribemediadigital-betaui.azurewebsites.net/Get/Index/70894_16_SD",
          adData: {
            impressions: 1000,
            clicks: 50,
            ctr: 5
          }
        }
      ],
      searchData: {
        calls: 0,
        websiteVisits: 0,
        websiteLinks: []
      }
    };
  },
  watch: {
    date1: {
      handler() {
        this.reload(this);
      },
      deep: true
    },

    date2: {
      handler() {
        this.reload(this);
      },
      deep: true
    }
  },
  async created() {
    const context = this;
    await this.reload(context);
  },
  methods: {
    getDefinitions: function() {
      return ADS_DEFINITIONS;
    },
    reload: async function(context) {
      context.TotalImpressions = 0;
      context.TotalClicks = 0;
      context.TotalCPC = 0.0;
      context.TotalCTR = 0.0;
      context.TotalComments = 0;
      context.TotalPageClicks = 0;
      context.TotalLikes = 0;
      context.TotalVideoViews = 0;
      context.TotalCampains.Impresiones = 0;
      context.TotalCampains.Clicks = 0;
      context.TotalCampains.CTR = 0;
      context.TotalCampains.CPC = 0;
      context.TotalCampains.Conversions = 0;
      context.TotalPhoneCalls = 0;
      context.phoneCalls = [];
      context.TotalLocationCampains.Impresiones = 0;
      context.TotalLocationCampains.Clicks = 0;
      context.TotalLocationCampains.Conversions = 0;

      context.ageSeries[0].data = [];
      context.genderSeries[0].data = [];
      context.devicesSeries[0].data = [];

      context.ageChartOptions.xaxis.categories = [];
      context.genderChartOptions.xaxis.categories = [];
      context.devicesChartOptions.xaxis.categories = [];

      context.campaignData = [];
      context.keywordData = [];
      context.keywordDataTotal = {};

      if (localStorage.getItem("isAxesa") == 1) {
        this.isAxesa = 1;
      }

      const { productId } = context.$route.params;
      const { customerId } = context.$route.query;

      const products = context.$store.state.subscriber.products;
      const validatedFinalDate = validateProductExpirationDate(products,productId,context.$store.state.subscriber.date1)

      let fromDate = context.$store.state.subscriber.date2 > validatedFinalDate ? validatedFinalDate : context.$store.state.subscriber.date2;
      let toDate = validatedFinalDate;

      const product = {
        clicks: [],
        impressions: [],
        totalImpressions: 0
      };

      const linkedinService = await getSummaryReport(customerId, fromDate, toDate);

      context.TotalImpressions = linkedinService.summaryReport.impressions;
      context.TotalClicks = linkedinService.summaryReport.clicks;
      context.TotalComments = linkedinService.summaryReport.commentLikes;
      context.TotalPageClicks = linkedinService.summaryReport.pageClicks;
      context.TotalLikes = linkedinService.summaryReport.likes;
      context.TotalVideoViews = linkedinService.summaryReport.videoViews;
      context.TotalCPC = linkedinService.summaryReport.cpc;
      context.TotalCTR = linkedinService.summaryReport.ctr;

      const campaignLocation = [];

      // impressions and clicks
      (linkedinService.reportsByDays || []).forEach(element => {
        context.impressionsSeries[0].data.push(element.impressions);
        context.impressionsSeries[1].data.push(element.clicks);
        context.impressionsChartOptions.xaxis.categories.push(element.date);

        product.clicks.push({ count: element.clicks, date: element.date });
        product.impressions.push({
          count: element.impressions,
          date: element.date
        });
      });

      context.Product = product;
      const campaign = [];
      linkedinService.campaigns.forEach(campaignData => {
        campaign.push({
          name: campaignData.name,
          impressions: campaignData.impressions,
          clicks: campaignData.clicks,
          ctr: campaignData.ctr,
          cpc: campaignData.cpc
        });
      });

      linkedinService.campaignLocations.locations.forEach(location => {
        campaignLocation.push({
          location: location.location,
          impressions: location.impressions,
          clicks: location.clicks
        });
      });

      context.campaignData = campaign;
      context.campaignLocationData = campaignLocation;
      context.TotalLocationCampains.Impresiones = linkedinService.campaignLocations.totalImpressions;
      context.TotalLocationCampains.Clicks = linkedinService.campaignLocations.totalClicks;

    }
  },
  computed: {
    ...mapGetters(["date1", "date2"])
  }
};
</script>
<style lang="scss" scoped>
.export {
  display: none;
}
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.widgets-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.pb-10 {
  padding-bottom: 10%;
}
.responsive-table {
  overflow-x: scroll;
}
.ad-data-copy {
  display: grid;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  grid-template-columns: 1fr 1fr 1fr;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
    p {
      font-size: 12px;
    }
  }
}
.google-box-content {
  > img {
    width: 60px;
    margin: 0 auto;
    display: block;
    margin-bottom: 10px;
  }
  .search-box {
    background-color: #fff;
    border-radius: 5px;
    .search-input {
      display: flex;
      justify-content: space-between;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 40px;
      overflow: hidden;
      box-sizing: border-box;
      p {
        font-size: 12px;
        padding: 8px 0px 8px 15px;
        margin-bottom: 0px;
        align-self: flex-start;
        color: $blueish-gray-700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .search-icon {
        background-color: $google;
        width: 40px;
        height: 36px;
        border-top-right-radius: 5px;
        align-self: flex-end;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .search-options {
      overflow: hidden;
      padding: 0px;
      margin-top: 5px;

      ul {
        display: flex;
        li {
          padding: 5px 10px;
          color: #c0c0c0;
          text-transform: uppercase;
          font-size: 8px;
          font-weight: $font-medium;
          &.active {
            color: $google;
            border-bottom: 2px solid $google;
          }
        }
      }
    }
  }
  .search-results {
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    box-shadow: $blueShadow;
    border-radius: 5px;
    max-height: 175px;
    .result-title {
      color: $google;
      margin-bottom: 0px;
      font-size: 12px;
      text-align: left;
    }
    .result-url {
      display: flex;
      align-items: baseline;
      span {
        color: #66c18d;
        padding: 0px 2px;
        border: 1px solid #66c18d;
        border-radius: 5px;
        font-size: 10px;
        margin-right: 5px;
      }
      p {
        color: #66c18d;
        font-size: 10px;
        margin-bottom: 7px;
      }
    }
    .result-separator {
      width: 100%;
      height: 1px;
      background: #e0e0e0;
    }
    .result-description {
      p {
        font-size: 10px;
        margin: 5px 0px 0px 0px;
        text-align: left;
      }
    }
  }
}
.demographic-data {
  h5 {
    font-size: 16px;
    color: $blueish-gray-600;
  }
}

.full-column {
  grid-column: 1 / -1;
}

@include respond-above(ss) {
  .widgets-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .google-box-content {
    max-width: 350px;
    margin: 0 auto;
    > img {
      width: 70px;
    }
    .search-results {
      .result-title {
        font-size: 12px;
      }
      .result-url {
        p {
          font-size: 12px;
        }
      }
      .result-description {
        p {
          font-size: 12px;
        }
      }
    }
  }
}

@include respond-above(md) {
  .widgets-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }
  .product-view {
    display: grid;
    grid-template: 1fr auto / 1fr minmax(300px, 350px);
    grid-column-gap: 30px;
    max-width: 1000px;
    margin: 0 auto;
    .widget-look {
      grid-row: 1 / -1;
      grid-column: 2;
    }
    .widget {
      &.keyword-widget,
      &.campaign-widget {
        grid-column: 1 / -1;
      }
    }
    .separator {
      grid-column: 1 / -1;
      margin-bottom: 20px;
    }
    .demographic-data {
      grid-column: 1 / -1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 30px;
      & > .widget-title {
        text-align: center;
        grid-column: 1 / -1;
        margin-bottom: 30px;
      }
      .widget:nth-child(4) {
        grid-column: 1 / -1;
      }
    }
    .two-column {
      grid-column: 1 / -1;
    }
    .ad-views {
      grid-column: 1 / -1;
      .cards-wrapper {
        display: grid;
        grid-gap: 30px;
      }
    }
  }
  .google-box-content {
    > img {
      width: 90px;
    }
    .search-box {
      .search-input {
        p {
          font-size: 14px;
        }
      }
      .search-options {
        ul {
          li {
            font-size: 10px;
            padding: 7px 15px;
          }
        }
      }
    }
    .search-results {
      max-height: 145px;
      .result-title {
        font-size: 14px;
      }
    }
  }
}

.two-column {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  .ad-data {
    ul {
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
    }
  }

  .ad-views {
    grid-column: 1 / -1;
    .ad-listing {
      padding: 0;
    }
  }
  .cards-calls-website {
    grid-column: 1 / -1;
  }
}

.ad-data {
  text-align: center;
  h1 {
    font-size: 52px;
    font-weight: 500;
    color: #3576ff;
  }
}

@include respond-above(sm) {
  .two-column {
    .ad-views {
      grid-column: 1;
    }
    .cards-calls-website {
      grid-column: 2;
    }
    .ad-data {
      &.calls {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// loading

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ellipsis div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #3576ff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 26px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 45px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
</style>
